import toast from "react-hot-toast";

export default {
  error: (message: string) => {
    toast.error(message, {
      duration: 10000,
    });
  },
  info: (message: string) => {
    toast(message);
  },
  loading: (message: string) => {
    toast.loading(message);
  },
  success: (message: string) => {
    toast.success(message);
  },
};
